import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import {
  WorkingCapitalScreen,
  type WorkingCapitalSearch,
} from '@/features/accounting-working-capital/working-capital-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/working-capital')({
  validateSearch: (search: Record<string, unknown>): WorkingCapitalSearch => ({
    as_at: typeof search.as_at === 'string' && search.as_at !== '' ? search.as_at : undefined,
    segment:
      typeof search.segment === 'string' && search.segment !== '' ? search.segment : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: AccountingWorkingCapitalRoute,
})

function AccountingWorkingCapitalRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  return (
    <WorkingCapitalScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/accounting/working-capital', search: next, replace: true })
      }
    />
  )
}
